<!-- components/Loading.vue -->
<template>
	<div class="loading-overlay">
		<div class="loading-spinner">
			<i class="el-icon-loading"></i>
		</div>
	</div>
</template>

<script>
export default {
	name: "Loading"
};
</script>

<style scoped>
.loading-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(15, 23, 42, 0.12);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 9999;
	backdrop-filter: blur(1px);
}

.loading-spinner {
	width: 72px;
	height: 72px;
	border-radius: 18px;
	background: rgba(255, 255, 255, 0.95);
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 2rem;
	color: var(--app-primary);
	box-shadow: 0 10px 30px rgba(15, 23, 42, 0.18);
}
</style>
